import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../types/api-response";
import { PageScreen } from "../../types/search";
import axios from "../../utils/axiosInceptor";
import { apiV1Endpoint } from "./endpoints";

type PropertyOwners = {
  ownerId: string;
  ownerName: string;
};

type UseGetPropertyOwnersOptions = {
  screen: PageScreen;
  isEnabled?: boolean;
};

const getPropertyOwners = async (screen: PageScreen) => {
  const url = `${apiV1Endpoint}/property/owner/list`;
  const response = await axios.get<ApiResponse<PropertyOwners[]>>(url, { params: { screen } });
  return response.data.result;
};

export const useGetPropertyOwners = (options: UseGetPropertyOwnersOptions) => {
  const { screen, isEnabled } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["property-owners", screen],
    queryFn: () => getPropertyOwners(screen),
    enabled: isEnabled,
  });

  return {
    propertyOwners: data ?? [],
    isLoadingPropertyOwners: isLoading,
  };
};
